/**
 * @description Component-CrossMarketCheckbox
 */
import Checkbox from '@/components/Checkbox';
import './index.less';

import UnderlineToolTip from '@/components/ToolTip/UnderlineToolTip';
import { CHAIN_ID } from '@/constants/chain';
import { useTradeStore } from '@/features/trade/store';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  chainId: CHAIN_ID | undefined;
}
const CrossMarketCheckbox: FC<IPropTypes> = function ({ chainId }) {
  const { t } = useTranslation();
  const { isTurnOnCrossMarket, setIsTurnOnCrossMarket } = useTradeStore();

  return (
    <Checkbox
      className="syn-cross-market-checkbox"
      checked={!isTurnOnCrossMarket}
      onChange={() => {
        chainId && setIsTurnOnCrossMarket(!isTurnOnCrossMarket);
      }}>
      <UnderlineToolTip title={t('tooltip.tradePage.postOnlyTooltip')}>
        <span className="syn-cross-market-checkbox-text">{t('common.tradePage.postOnly')}</span>
      </UnderlineToolTip>
    </Checkbox>
  );
};

export default CrossMarketCheckbox;
